<template>
  <!-- <div
    class="dataset-cell-text"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
  >
    {{ props.value }}
  </div> -->
  <div class="field">
        <b-checkbox @input="change" v-model="isChecked"></b-checkbox>
    </div>
</template>

<script>
export default {
  name: 'DatasetCheckBox',
  props: {
    row: { type: Object, default: () => ({}) },
    columns: { type: Object, default: () => ({}) },
    checkedrows: {type: Array, default: () => []}
    // value: {
    //   type: [String, Number, Boolean, Array, Object],
    //   default: () => null,
    // },
  },
  data(){
      return{
          isChecked: false
      }
  },
  watch:{
    //   checkedrows: function(){
    //       console.log(this.checkedrows)
    //     this.isChecked = this.checkedrows.indexOf(this.row) !== -1
    //   }
    checkedrows: {
      handler: function (val, oldVal) {
         this.isChecked = this.checkedrows.indexOf(this.row) !== -1
         //console.log(this.isChecked)
      },
      deep: true
      }
  },
  methods: {
      change(){
          let index = this.checkedrows.indexOf(this.row)
          if(this.isChecked && index === -1){
              this.checkedrows.push(this.row)
          }
          else if(index !== -1){
              this.checkedrows.splice(index, 1)
          }
      }
  }
}
</script>
